import { ToggleButton, ToggleButtonItem, ToggleButtonLabelSize } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { useEffect, useState } from 'react';

interface YesNoToggleButtonProps {
    id: string;
    value: boolean | undefined;
    required?: boolean;
    requiredMessage?: string;
    onItemClick: (e: ButtonGroupTypes.ItemClickEvent) => void;
    width?: string;
    height?: string;
    label?: any;
    labelSize?: ToggleButtonLabelSize;
    disabled?: boolean;
    showInfoIcon?: boolean;
    infoText?: string;
}

export const YesNoToggleButton: React.FC<YesNoToggleButtonProps> = ({
    id,
    value,
    required = false,
    requiredMessage,
    onItemClick,
    width = '230px',
    height = '40px',
    label,
    labelSize = ToggleButtonLabelSize.None,
    disabled = false,
    showInfoIcon = false,
    infoText,
}) => {
    const [toggleButtonState, set_toggleButtonState] = useState<string[]>([]);
    const toggleButtonItemsYesNo: ToggleButtonItem[] = [
        {
            id: 'Yes',
            text: 'Yes',
            hint: 'Click Yes',
            disabled: disabled,
        },
        {
            id: 'No',
            text: 'No',
            hint: 'Click No',
            disabled: disabled,
        },
    ];

    useEffect(() => {
        let returnedValue = undefined;
        if (value != undefined && value != null) {
            if (value == true) {
                returnedValue = ['Yes'];
            } else {
                returnedValue = ['No'];
            }
        } else {
            returnedValue = [];
        }
        set_toggleButtonState(returnedValue);
    }, [value]);

    return (
        <ToggleButton
            id={id}
            items={toggleButtonItemsYesNo}
            selectedItems={toggleButtonState}
            selectionMode={value === undefined || value === null ? 'none' : 'single'}
            stylingMode='outlined'
            onItemClick={onItemClick}
            width={width}
            height={height}
            required={required}
            requiredMessage={requiredMessage}
            label={label}
            labelSize={labelSize}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
        />
    );
};
